import { Theme } from './types';

export const darkTheme: Theme = {
  colors: {
    background: "#282c34",
    text: "#fff",
    mutedText: "#ccc",
    hourlyItemBackground: "#1e2128",
    cardShadow: "rgba(0, 0, 0, 0.7)",
    toggleThemeBg: "#111",
    search: {
      shadow: "rgba(0, 0, 0, 0.30)",
      shadowFocus: "rgba(0, 0, 0, 0.5)",
      btnBackground: "#dfdfdf",
      btnText: "#222",
      btnHover: "#bfbfbf",
    },
    suggestionList: {
      background: "#20242b",
      itemHover: "#282c34",
      border: "#666",
      itemBorderBottom: "#444"
    },
  },
};